// @flow
import actionTypes from '../actionTypes';
import { fetch } from '../../api';


export function signupFailure(error: any, data: SignupData) {
  const type = actionTypes.SIGN_UP_FAILURE;
  const message =
      (error && error.status && error.status.message) ||
      String(error);
  return {
    type,
    alert: {
      type: actionTypes.SIGN_UP_FAILURE,
      message,
    },
    logData: data,
    error,
  };
}

type LoginSuccessData = { session: string, isActive: boolean, user: User };
export function signupSuccess({ session, isActive, user }: LoginSuccessData): any {
  if (!user) return signupFailure('no user returned by api');

  return {
    type: actionTypes.SIGN_UP_SUCCESS,
    session: { session, isActive, userId: user.id },
    data: { users: [user] },
  };
}

type SignupData = {
  password?: string,
  username: string,
  email: string,
  AccessToken?: string,
  IsVerified?: bool,
};
export function signup(data: SignupData) {
  return async function(dispatch: Dispatch) {
    dispatch({ type: actionTypes.SIGN_UP });

    try {
      const body = JSON.stringify(data);
      const { payload } = await fetch('profile', { method: 'POST', body });

      dispatch(signupSuccess(payload));
    } catch (error) {
      dispatch(signupFailure(error, data));
    }
  };
}



// WEBPACK FOOTER //
// ./~/virgo/src/actions/userFlowActionsCreator/signup.js